const initialState = {
  hash: "",
  languages: [],
  translation: {},
};

// eslint-disable-next-line
export default function (state = initialState, action) {
  switch (action.type) {
    default:
      return state;
  }
}
